import { render } from "./index.vue?vue&type=template&id=16e7b02c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=16e7b02c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/extra/VabJsonViewer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16e7b02c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16e7b02c', __exports__)) {
    console.log('reload')
    api.reload('16e7b02c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=16e7b02c", () => {
    console.log('re-render')
    api.rerender('16e7b02c', render)
  })

}


export default __exports__